var React = require('react');

var Select = require('react-bootstrap/lib/SplitButton');
var Option = require('react-bootstrap/lib/MenuItem');

var Button = require('react-bootstrap/lib/Button');
var Modal = require('react-bootstrap/lib/Modal');
var Carousel = require('react-bootstrap/lib/Carousel');
var Form = require('react-bootstrap/lib/Form');
var FormControl = require('react-bootstrap/lib/FormControl');
var FormGroup = require('react-bootstrap/lib/FormGroup');
var ControlLabel = require('react-bootstrap/lib/ControlLabel');

var firebase = require('../../../firebase');
var { fbDb } = firebase;


var style = {
	container: {
		margin: 10
	}
};

var RequestsStatus = React.createClass({

	getInitialState() {
    	return {
    		opened: false,
    		email: ""
    	};
  	},

  	load: function() {
  		var me = this;
  		if(me.props.rowData.paymentData) {
  			me.state.email = me.props.rowData.paymentData.email;
  		}
  	},

  	save() {
  		var me = this;
  		var key = me.props.rowData.id
  		var email = me.state.email;
  		var idClient = me.props.rowData.idClient;

  		fbDb.ref('settings/fees').once("value", (fsnap) => {
  			const fees = fsnap.val();
  			fbDb.ref('orders/'+key).once("value", (snap) => {
			const order = snap.val();
			fbDb.ref('couriers').orderByChild("info/email").equalTo(email).once("value", (_snap) => {
				const users = _snap.val();
				const orderValue = order.orderValue ? order.orderValue : (order.value * ((100 - fees) * 0.01));
				for(var idx in users) {
					me.props.courierOrder(key, idClient, idx, {
						createdAt: order.createdAt,
						id: key,
						order: order.order,
						status: 2,
						totalDistance: order.totalDistance,
						value: orderValue
					});
					break;
				}
			});
		});
  		});

  	  	me.close();
  	},

  	open() {
  		
  		var me = this;

  		me.load();
  		
  		this.setState({opened: true});
  	},

  	close() {
  	  this.setState({opened: false});
  	},

  	onInputChange: function(e) {
	    this.setState({[e.target.name]: e.target.value});
	},

	removeCourier(data) {
		if(confirm("Deseja remover o entregador?")) {
			this.props.removeCourier(data.orderId, data.clientId, data.courierId);
		}
	},

	finishOrder(data) {
		if(confirm("Deseja encerrar o pedido?")) {
			this.props.finishOrder(data.orderId, data.clientId, data.courierId);
		}
	},

	getSelectId: function() {
		return 'userstatus'.concat(Date.now());
	},

	getTitle: function(status, data) {
		var label, _status = data.status;

		switch(status) {
			case 0:
				label = _status === 2 ? 'Remover entregador' : 'Escolher entregador';
				break;

			case 1:
				label = 'Encerrar o pedido';
				break;

			default:
				label = 'Selecione ação';
				break;
		}

		return label;
	},

	render: function() {
		var me = this, status = me.props.data, data = me.props.rowData;
		var _status = data.status;

		if(_status === 2) {
			return (
	    		<Select 
					bsStyle='default' 
					bsSize='xsmall' 
					title={me.getTitle(status, data)} 
					id={me.getSelectId()}
				>
					<Option
						eventKey={{orderId: data.id, clientId: data.idClient, courierId: data.idCourier}}
						onSelect={me.removeCourier}
					>
						{"Remover entregador"}
					</Option>
					<Option 
						eventKey={{orderId: data.id, clientId: data.idClient, courierId: data.idCourier}}
						onSelect={me.finishOrder}
					>
						{"Encerrar o pedido"}
					</Option>
				</Select>
	    	)
		} else {
			return (
				<div>
		    		<Select 
						bsStyle='default' 
						bsSize='xsmall' 
						title={me.getTitle(status, data)} 
						id={me.getSelectId()}
					>
						<Option
							eventKey={{orderId: data.id, clientId: data.idClient, courierId: data.idCourier}}
							onSelect={me.open}
						>
							{"Escolher entregador"}
						</Option>
					</Select>

					<Modal show={me.state.opened} onHide={me.close}>
		    			<div style={style.container}>
			    			<Form onChange={me.onInputChange} className="initOrder activebox">
								<FormGroup  controlId="formEmail">
								<ControlLabel>Entregador:</ControlLabel>
									<FormControl 
										name="email"
										type="text"
										data-checkout="cardholderName" 
										placeholder="E-mail do entregador"
										onChange={me.onInputChange}
									/>
								</FormGroup>
								<FormGroup  controlId="formButton">
									<Button onClick={me.save}
											block
											bsStyle="primary"
											style={{width: '50%', backgroundColor: '#5CB85C', borderColor: '#4CAE4C', color: '#FFFFFF'}}>
											{"Salvar"}
									</Button>
								</FormGroup>
							</Form>
						</div>
					</Modal>
				</div>
	    	)
		}
	}

});

module.exports = RequestsStatus;


// WEBPACK FOOTER //
// ./src/components/Admin/Requests/Actions.jsx